export function updateMultiParameterCategories<Field, State, Api>(
  field: Field,
  onFieldUpdate: (field: Field, value: Api | null) => void,
  state: State,
  mapStateToApi: (state: State) => Api | null
): void {
  onFieldUpdate(field, mapStateToApi(state));
}
